import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { CommonSelect } from "../common";
import { CommonButton } from "../common/commonButton";
import { Box, Grid, FormLabel, Collapse, CircularProgress, IconButton, TextField, Typography, Checkbox } from "@mui/material";
import instance from "../../redux/api";
import MUIDataTable from "mui-datatables";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { userPermissionAPI } from "../../Services/api";
import CloseIcon from "@mui/icons-material/Close";
import { commonToast } from "../common";
import {
  primaryButtonStyle,
  secondaryButtonStyle,
  submitButtonStyle,
  primaryButtonHoverColor,
  primaryBlueColor,
  checkboxStyle,
} from "../common/commonButtonStyles";
import "../common/commonPageStyles.css";

export default function UserPermissionContainer() {
  const toggle = useSelector((state) => state.toggleSideMenu);
  const { userData } = useSelector((state) => state?.user);
  const [tableRows, setTableRows] = useState([]);
  const [transformedData, setTransformedData] = useState([]);
  const [isApiCallInprogress, setIsApiCallInprogress] = useState(false);
  const [isAddRoleInprogress, setIsAddRoleInprogress] = useState(false);
  const [checkBoxLoader,setCheckBoxLoader] = useState(false)
  const [selectedRole, setSelectedRole] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [openAddRoleDialog, setOpenAddRoleDialog] = useState(false)
  const [expandedWorkflowRows, setExpandedWorkflowRows] = useState([]);
  const [expandedWorkstepRows, setExpandedWorkstepRows] = useState({});

  const UserAuthorisation =
    userData?.user_permissions?.permissions_list['Admin Table Maintenance'];

  const Container = {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    gap: 0,
    height: "calc(100vh - 180px)",
    maxHeight: "calc(100vh - 180px)",
    overflow: "hidden",
    position: "relative",
  };

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      setIsApiCallInprogress(true);
      const resp = await instance.get(userPermissionAPI);
      setIsApiCallInprogress(false);
      if (resp.status === 200) {
        const sortedData = resp.data;
        setTableRows(sortedData);
        const columnKeys = columns.map(column => column.field);
        const transformedData = sortedData?.map(item =>
          columnKeys.map(key => item[key] !== undefined ? item[key] : null)
        );
        setTransformedData(transformedData);
      } else {
        setTableRows([]);
        setTransformedData([]);
      }
    } catch (err) {
      setIsApiCallInprogress(false);
      console.error("err", err);
    }
  };

  const handleCancelAddingRole = () => {
    setOpenAddRoleDialog(false);
    setIsEdit(false);
    setFormData({
      role: "",
      module: "",
      permissions: [],
      addModule: false
    })
  }
  
  const handleAddRole = async () => {
    try {
      setIsAddRoleInprogress(true);
      if (isEdit){
        const resp = await instance.post(userPermissionAPI, formData);
        setIsAddRoleInprogress(false);
        if (resp.status === 200) {
          commonToast("success", "Module added successfully.");
          setFormData({
            role: "",
            module: "",
            permissions: [],
            addModule: false
          });
          setOpenAddRoleDialog(false);
          loadData();
          setIsEdit(false);
        } else {
          commonToast("error", "Module addition failed. Please try again later.");
        }
      } else {
        const resp = await instance.post(userPermissionAPI, formData);
        setIsAddRoleInprogress(false);
        if (resp.status === 201) {
          commonToast("success", "Role added successfully.");
          setFormData({
            role: "",
            module: "",
            permissions: [],
            addModule: false
          });
          setOpenAddRoleDialog(false);
          loadData();
        } else {
          commonToast("error", "Role addition failed. Please try again later.");
        }
      }
    } catch (err) {
      setIsAddRoleInprogress(false);
      console.error("err", err);
      commonToast("error", err?.data?.error || "Role addition failed. Please try again later.");
    }
  };

  const handleEditClick = () => {
    setIsEdit(true);
    setOpenAddRoleDialog(true);
    setFormData({
      ...formData,
      ['role']: selectedRole,
      ['addModule']: true
    })
  }

  const options = {
    onFilterChange: (changedColumn, filterList) => {
      console.log(changedColumn, filterList);
    },
    selectableRows: "none", // Disable default selectable rows
    filterType: "dropdown",
    pagination: false,
    expandableRows: true,
    expandableRowsHeader: false,
    download: false,
    print: false,
    search: false,
    filter: false,
    viewColumns: false,
    serverSide: true,
    selectToolbarPlacement: 'none',
    renderExpandableRow: (rowData, rowMeta) => {
      const originalRow = tableRows[rowMeta.dataIndex];
      return renderExpandableRowForModule(originalRow, rowMeta);
    },
    customToolbarSelect: () => {
      return isApiCallInprogress ? <CircularProgress size={24} /> : null;
    },
    textLabels: {
      body: {
        noMatch: isApiCallInprogress ? <CircularProgress size={24} /> : "Sorry, no data found module",
      },
    },
    rowsExpanded: expandedWorkflowRows,
    onRowExpansionChange: (curExpanded, allExpanded) => {
      if (allExpanded.length === 0) {
        setExpandedWorkflowRows([]);
      } else {
        const lastExpanded = allExpanded[allExpanded.length - 1].index;
        const workflowRow = tableRows?.[lastExpanded];
        setSelectedRole(workflowRow?.role);
        setExpandedWorkflowRows([lastExpanded]);
      }
    },
  };

  const renderExpandableRowForModule = (rowData, rowMeta) => {
    const workflowRow = tableRows?.find(row => {
      return row.id === rowData.id
    });
    const worksteps = tableRows?.find(row => row.id === rowData.id)?.permissions_list || {};
    const workstepTransformedData = Object.keys(worksteps).map(key => [key]);
    const workstep_options = {
      onFilterChange: (changedColumn, filterList) => {
        console.log(changedColumn, filterList);
      },
      selectableRows: "none", // Disable default selectable rows
      filterType: "dropdown",
      pagination: false,
      expandableRows: true,
      expandableRowsHeader: false,
      download: false,
      print: false,
      search: false,
      filter: false,
      viewColumns: false,
      serverSide: true,
      selectToolbarPlacement: 'none',
      responsive: "standard",
      renderExpandableRow: (rowData, rowMeta) => renderExpandableRowForWorkstepPermissions(rowData, rowMeta, workflowRow),
      customToolbarSelect: () => {
        return isApiCallInprogress ? <CircularProgress size={24} /> : null;
      },
      textLabels: {
        body: {
          noMatch: isApiCallInprogress ? <CircularProgress size={24} /> : "Sorry, no data found permission",
        },
      },
      rowsExpanded: expandedWorkstepRows[rowData],
      onRowExpansionChange: (curExpanded, allExpanded) => {
        if (allExpanded.length === 0) {
          setExpandedWorkstepRows({ 
            ...expandedWorkstepRows,
            [rowData]: [] 
          });
        } else {
          const lastExpanded = allExpanded[allExpanded.length - 1].index;
          setExpandedWorkstepRows({
            ...expandedWorkstepRows,
            [rowData]: [lastExpanded] // only one expanded row per workflow
          });
        }
      },
    };

    return (
      <TableRow>
        <TableCell colSpan={columns.length + 1} sx={{ padding: "8px", backgroundColor: "#fafafa", overflow: "hidden", maxWidth: "100%" }}>
          <Collapse in={true} timeout="auto" unmountOnExit>
            <Box sx={{ width: "100%", overflowX: "hidden", maxWidth: "100%", padding: "0 8px" }}>
              <TableContainer 
                sx={{ 
                  width: "100%",
                  backgroundColor: "#ffffff",
                  borderRadius: "8px",
                  border: "1px solid #e0e0e0",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                  overflowX: "hidden",
                  overflowY: "visible",
                  maxWidth: "100%",
                }} 
                component={Paper} 
                className="collapse-table-container"
              >
                <Box sx={{ overflowX: "hidden", maxWidth: "100%", width: "100%" }}>
                  <MUIDataTable
                    className="table_row_workstep"
                    data={workstepTransformedData}
                    columns={workstep_columns}
                    options={workstep_options}
                  />
                </Box>
              </TableContainer>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    );
  };
  
  // Store permissions in state to make checkboxes editable
  const [permissions, setPermissions] = useState({});
  const [selectedModule, setSelectedModule] = useState({});
  const [selectedID, setSelectedID] = useState({});
  const handleCheckboxChange = async (key) => {
    const newValue = permissions[key] === "Y" ? "N" : "Y";

    setPermissions((prev) => ({
      ...prev,
      [key]: newValue,
    }));

    const payload = {
      permission_key: key,
      value: newValue,
      selectedModule: selectedModule
    };

    try {
      setCheckBoxLoader(true);
      await instance.patch(userPermissionAPI+`${selectedID}/`, payload);
      setCheckBoxLoader(false);
      setTableRows(prev =>
        prev.map(row => {
          if (row.id !== selectedID) return row;
          return {
            ...row,
            permissions_list: {
              ...row.permissions_list,
              [selectedModule]: {
                ...row.permissions_list[selectedModule],
                [key]: newValue,
              }
            }
          };
        })
      );
    } catch (err) {
      setCheckBoxLoader(false);
      console.error("err", err);
    }
  };

  const renderExpandableRowForWorkstepPermissions = (rowData, rowMeta, workflowRow) => {
    const moduleValue = rowData[0]?.props?.children || "";
    setSelectedModule(moduleValue);
    setSelectedID(workflowRow?.id)
    const selectedPermissions = workflowRow?.permissions_list[moduleValue] || {};
    setPermissions(selectedPermissions);

    return (
      <>
        {
          Object.keys(selectedPermissions).length > 0 && (
            <TableRow>
              <TableCell colSpan={workstep_columns.length + 1} sx={{ padding: "16px 0", backgroundColor: "#f5f5f5" }}>
                <Collapse in={true} timeout="auto" unmountOnExit>
                  <TableContainer 
                    sx={{ 
                      width: "95%", 
                      marginLeft: "2.5%",
                      backgroundColor: "#ffffff",
                      borderRadius: "8px",
                      border: "1px solid #e0e0e0",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                    }} 
                    component={Paper} 
                    className="collapse-table-container"
                  >
                    <Table aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell 
                            className="user_id_column"
                            sx={{
                              backgroundColor: "#f8f9fa",
                              color: "#333",
                              fontWeight: "600",
                              fontSize: "14px",
                              borderBottom: "2px solid #e0e0e0",
                              padding: "12px 16px",
                            }}
                          >
                          </TableCell>
                          <TableCell 
                            className="user_name_column"
                            sx={{
                              backgroundColor: "#f8f9fa",
                              color: "#333",
                              fontWeight: "600",
                              fontSize: "14px",
                              borderBottom: "2px solid #e0e0e0",
                              padding: "12px 16px",
                            }}
                          >
                            Permission
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {Object.entries(selectedPermissions).map(([key, value]) => (
                          <TableRow 
                            key={key}
                            sx={{
                              borderBottom: "1px solid #f0f0f0",
                              "&:hover": {
                                backgroundColor: "rgba(22, 114, 222, 0.04) !important",
                              },
                              "&:nth-of-type(even)": {
                                backgroundColor: "#fafafa",
                                "&:hover": {
                                  backgroundColor: "rgba(22, 114, 222, 0.04) !important",
                                },
                              },
                            }}
                          >
                            <TableCell
                              sx={{
                                fontSize: "14px",
                                color: "#333",
                                padding: "12px 16px",
                              }}
                            >
                              <Checkbox
                                checked={value === "Y"}
                                onChange={(e) => handleCheckboxChange(key)}
                                disabled={UserAuthorisation?.["Edit"] === "N"}
                                sx={checkboxStyle}
                              />
                            </TableCell>
                            <TableCell
                              sx={{
                                fontSize: "14px",
                                color: "#333",
                                padding: "12px 16px",
                              }}
                            >
                              {key}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Collapse>
              </TableCell>
            </TableRow>
          )
        }
      </>
    )
  }

  const columns = [
    // {
    //   field: "id",
    //   name: "ID",
    //   headerAlign: "left",
    //   width: 10,
    //   maxWidth: 30
    // },
    { 
      field: "id", 
      name: "Serial No",
      options: {
        customBodyRenderLite: (dataIndex) => dataIndex + 1,
        setCellProps: () => ({
          style: { width: "100px", maxWidth: "100px", textAlign: "center" }
        }),
        setCellHeaderProps: () => ({
          style: { width: "100px", maxWidth: "100px", textAlign: "center" }
        })
      }
    },
    {
      field: "role",
      name: "Role",
      headerAlign: "left",
      width: 150,
      options: {
        customBodyRender: (value) => (
          <div style={{ textAlign: 'left' }}>{value}</div>
        ),
      },
    }
  ]

  const workstep_columns = [
    {
      field: "module",
      name: "Module",
      headerAlign: "left",
      options: {
        customBodyRender: (value) => (<div style={{ textAlign: 'left' }}>{value}</div>),
        setCellProps: () => ({
          style: { 
            width: "auto",
            minWidth: "200px",
            maxWidth: "calc(100% - 200px)",
          }
        }),
        setCellHeaderProps: () => ({
          style: { 
            width: "auto",
            minWidth: "200px",
            maxWidth: "calc(100% - 200px)",
          }
        })
      },
    },
    {
      field: "actions",
      name: "Actions",
      headerAlign: "right",
      options: {
        customHeadRender: (columnMeta) => {
          return (
            <th style={{ padding: "8px", textAlign: "right", width: "auto", minWidth: "140px" }}>
              <Box display="flex" justifyContent="flex-end" alignItems="center" sx={{ width: "100%" }}>
                <CommonButton
                  text="Add Module"
                  handleClick={handleEditClick}
                  disabled={UserAuthorisation?.["Creation"] === "N"}
                  sx={{
                    ...primaryButtonStyle,
                    minWidth: "120px",
                    padding: "8px 16px",
                    fontSize: "14px",
                    whiteSpace: "nowrap",
                  }}
                  hoverColor={primaryButtonHoverColor}
                />
              </Box>
            </th>
          );
        },
        customBodyRender: (value) => (
          <div style={{ textAlign: 'right' }}></div>
        ),
        setCellProps: () => ({
          style: { 
            width: "auto",
            minWidth: "140px",
            textAlign: "right",
          }
        }),
        setCellHeaderProps: () => ({
          style: { 
            width: "auto",
            minWidth: "140px",
            textAlign: "right",
          }
        })
      },
    },
  ];


  const roleOptions = [
    'Add',
    'Edit',
    'View',
    'Delete'
  ]

  const [formData, setFormData] = useState({
    role: "",
    module: "",
    permissions: [],
    addModule: false
  });

  const handleInputChange = (key, value) => {
    setFormData({
      ...formData,
      [key]: value
    })
  }

  const handleFilterDropdown = (name, value) => {
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  return (
    <>
      <style>
        {`
          /* Override MUIDataTable column headers to match other screens */
          .table_row th,
          .table_row_workstep th {
            background-color: #f8f9fa !important;
            color: #333 !important;
            font-weight: 600 !important;
            border-bottom: 2px solid #e0e0e0 !important;
          }
          .table_row th button,
          .table_row_workstep th button {
            background-color: transparent !important;
            color: #333 !important;
            border-left: 1px solid #e0e0e0 !important;
          }
          .table_row tbody tr:hover,
          .table_row_workstep tbody tr:hover {
            background-color: rgba(22, 114, 222, 0.04) !important;
          }
          .table_row tbody tr:nth-of-type(even),
          .table_row_workstep tbody tr:nth-of-type(even) {
            background-color: #fafafa !important;
          }
          .table_row tbody tr:nth-of-type(even):hover,
          .table_row_workstep tbody tr:nth-of-type(even):hover {
            background-color: rgba(22, 114, 222, 0.04) !important;
          }
          /* Prevent horizontal scrollbar in nested tables */
          .collapse-table-container {
            overflow-x: hidden !important;
            max-width: 100% !important;
            width: 100% !important;
          }
          .collapse-table-container > * {
            overflow-x: hidden !important;
            max-width: 100% !important;
            width: 100% !important;
          }
          .collapse-table-container .MuiTableContainer-root {
            overflow-x: hidden !important;
            max-width: 100% !important;
            width: 100% !important;
          }
          .table_row_workstep {
            overflow-x: hidden !important;
            max-width: 100% !important;
            width: 100% !important;
          }
          .table_row_workstep > div {
            overflow-x: hidden !important;
            max-width: 100% !important;
            width: 100% !important;
          }
          .table_row_workstep .MuiTableContainer-root {
            overflow-x: hidden !important;
            max-width: 100% !important;
            width: 100% !important;
          }
          .table_row_workstep table {
            width: 100% !important;
            max-width: 100% !important;
            table-layout: fixed !important;
          }
          .table_row_workstep th {
            white-space: nowrap !important;
            overflow: visible !important;
          }
          .table_row_workstep td {
            white-space: nowrap !important;
            overflow: hidden !important;
            text-overflow: ellipsis !important;
          }
          .table_row_workstep th:last-child {
            overflow: visible !important;
          }
          .table_row_workstep td:last-child {
            overflow: visible !important;
          }
        `}
      </style>
      <div style={Container}>
        {/* Main Content Area */}
        <Box className="main-content-area">
          <Box className="page-header-container">
            <Typography variant="h5" className="page-heading">
              User Permissions Table
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
              {UserAuthorisation?.["Creation"] === "Y" && (
                <CommonButton
                  text="Add Role"
                  handleClick={() => setOpenAddRoleDialog(true)}
                  sx={primaryButtonStyle}
                  hoverColor={primaryButtonHoverColor}
                />
              )}
            </Box>
          </Box>

          <Box
            sx={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              minHeight: 0,
              position: "relative",
              backgroundColor: "#ffffff",
              borderRadius: "12px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
              overflow: "hidden",
              transition: "all 0.3s ease",
              border: "1px solid #e0e0e0",
              width: "100%",
            }}
          >
            {/* Overlay Loader */}
            {checkBoxLoader && (
              <Box
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  background: "rgba(255, 255, 255, 0.8)",
                  zIndex: 9999,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress sx={{ color: primaryBlueColor }} />
              </Box>
            )}
            {isApiCallInprogress ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                  minHeight: "400px",
                }}
              >
                <CircularProgress sx={{ color: primaryBlueColor }} />
              </Box>
            ) : (
              transformedData && (
                <Box 
                  sx={{ 
                    flex: 1, 
                    overflow: "auto", 
                    padding: "20px",
                    "&::-webkit-scrollbar": {
                      width: "8px",
                      height: "8px",
                    },
                    "&::-webkit-scrollbar-track": {
                      background: "#f1f1f1",
                      borderRadius: "10px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "#c1c1c1",
                      borderRadius: "10px",
                      "&:hover": {
                        background: "#a8a8a8",
                      },
                    },
                  }}
                >
                  <MUIDataTable
                    className="table_row"
                    data={transformedData}
                    columns={columns}
                    options={options}
                  />
                </Box>
              )
            )}
          </Box>
        </Box>
        {/* This is for Adding role */}
        <Dialog 
          open={openAddRoleDialog} 
          onClose={handleCancelAddingRole}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: "12px",
              boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
            }
          }}
        >
          <DialogTitle
            id="alert-dialog-title" 
            sx={{ 
              cursor: "default", 
              paddingBottom: "0px",
              padding: "20px 24px 16px 24px",
              backgroundColor: "#f8f9fa",
              borderBottom: "1px solid #e0e0e0",
            }}
          >
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Typography
                variant="h6"
                sx={{
                  color: primaryBlueColor,
                  fontWeight: 600,
                  fontSize: "18px",
                  margin: 0,
                }}
              >
                {isEdit ? "Add Module" : "Add Role"}
              </Typography>
              <IconButton
                aria-label="close"
                onClick={handleCancelAddingRole}
                sx={{
                  position: "absolute",
                  right: 12,
                  top: 12,
                  color: "#666",
                  "&:hover": {
                    backgroundColor: "rgba(22, 114, 222, 0.1)",
                    color: primaryBlueColor,
                  },
                }}
              >
                <CloseIcon />
              </IconButton>
            </Box>
          </DialogTitle>

          <DialogContent sx={{ padding: "24px" }}>
            <Grid container spacing={3} sx={{ mt: 0 }}>
              <Grid
                item
                xs={12}
                display={"flex"}
                flexDirection={"column"}
                gap={"8px"}
              >
                <FormLabel
                  sx={{
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#333",
                    marginBottom: "4px",
                  }}
                >
                  Role
                </FormLabel>
                <TextField
                  type="text"
                  value={formData?.role}
                  onChange={(event) =>
                    handleInputChange("role", event.target.value)
                  }
                  placeholder="Add role"
                  disabled={isEdit}
                  size="small"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#e0e0e0",
                      },
                      "&:hover fieldset": {
                        borderColor: primaryBlueColor,
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: primaryBlueColor,
                        borderWidth: "2px",
                      },
                    },
                  }}
                />
              </Grid>
              <Grid
                item
                xs={12}
                display={"flex"}
                flexDirection={"column"}
                gap={"8px"}
              >
                <FormLabel
                  sx={{
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#333",
                    marginBottom: "4px",
                  }}
                >
                  Module
                </FormLabel>
                <TextField
                  type="text"
                  value={formData?.module}
                  onChange={(event) =>
                    handleInputChange("module", event.target.value)
                  }
                  placeholder="Add Module"
                  size="small"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#e0e0e0",
                      },
                      "&:hover fieldset": {
                        borderColor: primaryBlueColor,
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: primaryBlueColor,
                        borderWidth: "2px",
                      },
                    },
                  }}
                />
              </Grid>
              <Grid 
                item
                xs={12}
                display={"flex"}
                flexDirection={"column"}
                gap={"8px"}
              >
                <FormLabel
                  sx={{
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#333",
                    marginBottom: "4px",
                  }}
                >
                  Role Permissions
                </FormLabel>
                <CommonSelect
                  multiple={true}
                  placeholder="Select Permissions"
                  value={formData?.permissions  || []}
                  handleChange={(event, value) => handleFilterDropdown("permissions", value)}
                  options={roleOptions || []}
                />
              </Grid>
            </Grid>
          </DialogContent>

          <DialogActions 
            sx={{ 
              justifyContent: "flex-end", 
              padding: "16px 24px 24px 24px",
              borderTop: "1px solid #e0e0e0",
              backgroundColor: "#fafafa",
              gap: "12px",
            }}
          >
            <CommonButton 
              text="Cancel" 
              handleClick={handleCancelAddingRole}
              sx={secondaryButtonStyle}
              hoverColor={primaryButtonHoverColor}
            />
            {isAddRoleInprogress ? (
              <CircularProgress size={20} sx={{ color: primaryBlueColor }} />
            ) : (
              <CommonButton 
                text="Submit" 
                handleClick={handleAddRole} 
                disabled={
                  !formData?.role ||
                  !formData?.module ||
                  !formData?.permissions ||
                  formData?.permissions?.length === 0
                } 
                sx={submitButtonStyle}
                hoverColor={primaryButtonHoverColor}
              />
            )}
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
}